// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__N8OoJ","options":"AnswerScale_options__23PoH","selected":"AnswerScale_selected__3h2PC"};